import { wpFetch } from 'src/helpers/wpApiHandler';

const useAuthenticateUser = async (userToken) => {
  const response = await wpFetch(['authorization-check', userToken], {
    method: 'POST',
  });

  return response;
};

export default useAuthenticateUser;
